import { Chip, styled } from '../../base-components';

export const StyledChip = styled(Chip)<{ isSelected: boolean }>(
    ({ isSelected, theme }) => ({
        backgroundColor: isSelected
            ? theme.palette.info.main
            : theme.palette.common.white,
        color: isSelected
            ? theme.palette.common.white
            : theme.palette.grey[600],
        border: !isSelected ? `1px solid ${theme.palette.grey[600]}` : 'none',
        '&:hover': {
            backgroundColor: isSelected
                ? theme.palette.info.dark
                : theme.palette.grey[200],
        },
    })
);
